(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);
    
    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }
                // update the thumbnail active class
                section.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                section.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!document.querySelector(`.productFormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productFormSellingOptionPlan').value);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            let variant = section.querySelector(".productFormOptionsSelect").value;
            if (variant !== "") {
                activeVariant = JSON.parse(variant);
            }

        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelectorAll('.productATC').forEach(element => {
                element.disabled = true;
                element.querySelector(".productATCText").textContent = "Not Available";

            });
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productFormSellingOptionPriceCompare");
            const reals = section.querySelectorAll(".productFormSellingOptionPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price * quantity);
            }
            subReal.textContent = price(allocationPrice * quantity);

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price * quantity);
            }
            oneTimeReal.textContent = price(activeVariant.price * quantity);

            // check if subscription checked and update sticky price
            section.querySelector('.productStickyPrice').textContent = price(activeVariant.price * quantity);
            if (isSubscription()) {
                section.querySelector('.productStickyPrice').textContent = price(allocationPrice * quantity);
            }


        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productPriceCompare");
            const realEl = section.querySelector(".productPriceReal");

            realEl.classList.remove('sale');
            section.querySelector('.productBadgeSale').classList.remove('active');

            compareEl.textContent = '';

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price * quantity);
                realEl.classList.add('sale');

                // if the product isn't sold out, show sale badge
                if (activeVariant.available) {
                    section.querySelector('.productBadgeSale').classList.add('active');
                }

            }
            realEl.textContent = price(activeVariant.price * quantity);
            section.querySelector('.productStickyPrice').textContent = price(activeVariant.price * quantity);
        }


        /**************
         Available / Sold Out
         ***************/
        // when sold out, hide the product form and show the sold out form
        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").classList.remove('OOS');
            section.querySelector(".productATCText").textContent = "Add To Cart";
            section.querySelector('.productBadgeOOS').classList.remove('active');
            section.querySelector('.productOOSTitle').classList.remove('active');
            section.querySelector('.productPrice')?.classList.add('active');
            section.querySelectorAll('.productCans')?.forEach(element => {
                element.classList.add('active');
            });
            section.querySelector('.productOOSInput').classList.remove('active');
            section.querySelector('.productWrap').classList.remove('smallMargin');

            // selling plan / variant options
            if (product.selling_plan_groups.length > 0) {
                section.querySelector('.productFormSelling').classList.add('active');
            }
            if (product.variants.length > 1) {
                section.querySelector('.productFormOptions').classList.add('active');
            }
            section.querySelector('.productSticky').classList.add('active');

        } else {
            section.querySelector(".productATC").classList.add('OOS');
            section.querySelector(".productATCText").textContent = "Submit";
            section.querySelector('.productBadgeOOS').classList.add('active');
            section.querySelector('.productOOSTitle').classList.add('active');
            section.querySelector('.productPrice')?.classList.remove('active');
            section.querySelectorAll('.productCans')?.forEach(element => {
                element.classList.remove('active');
            });
            section.querySelector('.productOOSInput').classList.add('active');
            section.querySelector('.productBadgeSale').classList.remove('active');
            section.querySelector('.productWrap').classList.add('smallMargin');

            // selling plan / variant options
            if (product.selling_plan_groups.length > 0) {
                section.querySelector('.productFormSelling').classList.remove('active');
            }
            if (product.variants.length > 1) {
                section.querySelector('.productFormOptions').classList.remove('active');
            }

            section.querySelector('.productSticky').classList.remove('active');

        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/
    // minus
    section.querySelectorAll(".productQuantityControlsBtn.minus")?.forEach(element => {
        element.addEventListener("click", function () {
            if (quantity === 1) {
                return;
            }
            quantity--;
            section.querySelectorAll(".productQuantityControlsValue").forEach(element => {
                element.textContent = quantity;
            });
            updateProduct();
        });
    });

    // plus
    section.querySelectorAll(".productQuantityControlsBtn.plus")?.forEach(element => {
        element.addEventListener("click", function () {
            quantity++;
            section.querySelectorAll(".productQuantityControlsValue").forEach(element => {
                element.textContent = quantity;
            });
            updateProduct();
        });
    });


    /**************
     Product ATC
     ***************/

    section.querySelectorAll('.productATC').forEach(element => {
        element.addEventListener('click', async function () {

            // add loading animation to both buttons
            section.querySelectorAll(".productATC").forEach(element => {
                element.classList.add("loading");
            });

            // check for OOS
            if (element.classList.contains("OOS")) {

                // if input is empty, return
                if (section.querySelector('.productOOSInput').value === '') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Please enter a valid email address',
                    });
                    section.querySelectorAll(".productATC").forEach(element => {
                        element.classList.remove("loading");
                    });
                    return;
                }

                // add to OOS list and return
                await sendKlaviyoBackInStockRequest(section.querySelector('.productOOSInput').value, activeVariant.id);
                Swal.fire({
                    icon: 'success',
                    title: `Thanks! We'll let you know when this product is back in stock.`,
                });
                section.querySelectorAll(".productATC").forEach(element => {
                    element.classList.remove("loading");
                });
                return;
            }


            let formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                }]
            };

            // check for selling plan
            if (isSubscription()) {
                formData.items[0].selling_plan = parseInt(section.querySelector('.productFormSellingOptionPlan').value)
            }

            // add product
            await addProduct(formData);

            // remove loading animation
            section.querySelectorAll(".productATC").forEach(element => {
                element.classList.remove("loading");
            });

            // open cart
            await openCart();
        });
    });


    /** Block - Dropdown **/

    // setup dropdowns
    section.querySelectorAll(".productDropdownToggle").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });


    /**************
     Locations
     ***************/
    // hit geoip.maltertech.com to get the user's location
    // if province is california, show the locations link
    (async () => {
        await fetch("https://geoip.maltertech.com")
            .then(response => response.json())
            .then(data => {
                if (data.region === "California") {
                    section.querySelectorAll('.productLocation').forEach(element => {
                        element.classList.add('active');
                    });
                }
            });
    })();

    /**************
     Reviews link
     ***************/
    section.querySelectorAll('.productReviews')?.forEach(element => {
        element.addEventListener('click', function () {
            // smooth scroll to reviews
            document.querySelector('#reviews').scrollIntoView({
                behavior: 'smooth'
            });


        });
    });

    /**************
     Nutrition Dialog
     ***************/
    let nutritionExists = section.querySelector('.nutrition') || false;

    if (nutritionExists) {
        // swiper
        let nutritionSwiper = new Swiper(section.querySelector(".nutritionSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20
        });

        // thumbnails
        document.querySelectorAll('.nutritionSwiperThumbsBtn')?.forEach(element => {
            element.addEventListener('click', function () {

                document.querySelectorAll('.nutritionSwiperThumbsBtn').forEach(element => {
                    element.classList.remove('active');
                });

                element.classList.add('active');

                let target = this.dataset.target;
                nutritionSwiper.slideTo(target);

            });
        });

        // open nutrition dialog
        section.querySelectorAll('.openNutrition').forEach(function (element) {
            element.addEventListener('click', function () {
                section.querySelector(".nutrition").showModal();
                document.querySelector("body").classList.add("noScroll");
            });
        })

        // close nutrition
        function closePopup() {
            section.querySelector(".nutrition").close();
            document.querySelector("body").classList.remove("noScroll");
        }

        // close nutrition event listener
        section.querySelectorAll(".nutritionClose").forEach(function (element) {
            element.addEventListener("click", closePopup);
        });

        section.querySelector(".nutrition")?.addEventListener("click", function (e) {
            if (e.target === this) {
                closePopup();
            }
        })

        // close event
        section.querySelector(".nutrition")?.addEventListener("close", function () {
            document.querySelector("body").classList.remove("noScroll");
        });

        // register dialog
        dialogPolyfill.registerDialog(section.querySelector(".nutrition"));
    }
})();